import React from 'react';

/** Vertical divider used between data points in system cards. */
export default function Divider({ className = '' }) {
  return <div className={`ca-divider ${className}`.trim()} role="separator" aria-orientation="vertical" />;
}
